import React from 'react'
import Helmet from 'react-helmet'

export default props => <Helmet
  htmlAttributes={{ lang : 'ja' }}
  title={(props.title ? props.title + ' | ' : '') + 'DrupalCamp DEN 2022 OSAKA ONLINE'}
  meta={[
    { name: 'google-site-verification', content: 'H5p26Tfyi7RLtaRwmXUd-yAxAHlZgtKBzdJnkgWiZUU' },
    { name: 'description', content: '' },
    { name: 'viewport',
      content:'width=device-width, initial-scale=1,maximum-scale=1,minimum-scale=1, user-scalable=no',
    },
    { httpEquiv: 'content-language', content: 'ja' },
    { property: 'og:title', content: 'DrupalCamp DEN 2022 OSAKA ONLINE' },
    { property: 'og:type', content: 'website' },
    { property: 'og:description', content: '' },
    { property: 'og:url', content: 'https://drupal-camp2022.den-japan.org' },
    { property: 'og:site_name', content: 'DrupalCamp DEN 2022 OSAKA ONLINE' },
    { property: 'og:image', content: 'https://den-2021.netlify.app/static/72f2a14d2c7798e55dfad1baaa7e1ba5/b8ffe/Drupal_camp_Banner.png' },
  ]}
  link={[
      { rel: 'shortcut icon', type: 'image/png', href: 'https://den-japan.org/sites/default/files/den_logo_fav1.png' }
  ]}
/>
